import { Divider } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { CredusHeading, CredusText, CredusWrapper, color } from 'ui';

type ReportCardProps = {
  text?: string;
  value?: number | string;
  subText?: string | undefined;
  subValue?: number | string;
};

const ReportCard = ({ text, value, subValue, subText }: ReportCardProps) => {
  return (
    <CredusWrapper
      padding="1.25rem 1.8rem"
      display="flex"
      align="center"
      gap="1.8rem"
      bg="#FFFFFF"
      justify="center"
      radius="8px"
      border="0.5px solid #E0DEF7"
      elevation="0px 4px 8px rgba(0, 0, 0, 0.03)"
    >
      <div>
        <CredusText
          align="center"
          color="rgba(0, 0, 0, 0.39);"
          size="xs"
          weight="medium"
        >
          {text}
        </CredusText>
        <CredusHeading
          align="center"
          as="h4"
          weight="bold"
          color={color.primary}
        >
          {value}
        </CredusHeading>
      </div>
      {subValue !== null && subText && (
        <>
          <CustomDivider type="vertical" />
          <div>
            <CredusText
              align="center"
              color="rgba(0, 0, 0, 0.39);"
              size="xs"
              weight="medium"
            >
              {subText}
            </CredusText>
            <CredusHeading
              align="center"
              as="h4"
              weight="bold"
              color={color.primary}
            >
              {subValue}
            </CredusHeading>
          </div>
        </>
      )}
    </CredusWrapper>
  );
};

export default ReportCard;

const CustomDivider = styled(Divider)`
  height: 50px;
  width: 0px;
  margin-left: 0rem;
  margin-right: 0rem;
  border: 1px solid #e0def7;
`;
